import { render, staticRenderFns } from "./ClosestLots.vue?vue&type=template&id=0f94b9a1"
import script from "./ClosestLots.vue?vue&type=script&lang=js"
export * from "./ClosestLots.vue?vue&type=script&lang=js"
import style0 from "./ClosestLots.vue?vue&type=style&index=0&id=0f94b9a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports